import { motion } from 'framer-motion'
import { staggerParent } from './motion'

interface Props {
  children: React.ReactNode
  /** Full-bleed content above the padded column — a hero or a cover image. */
  bleed?: React.ReactNode
  className?: string
  /** Wider column for list-heavy screens like Routes. */
  width?: 'default' | 'wide'
  /** Tighter rhythm for a screen of short blocks read at a glance, like Home. */
  density?: 'default' | 'compact'
}

/**
 * Every screen's outer shell: the gym's page wash, one column, one rhythm.
 *
 * The stagger lives here rather than on each page so a screen's sections
 * arrive in sequence for free — each `<Section>` is already a variant child.
 */
export function Page({
  children,
  bleed,
  className = '',
  width = 'default',
  density = 'default',
}: Props) {
  return (
    <div className={`min-h-full bg-[var(--gym-page)] ${className}`}>
      {bleed}
      <motion.div
        initial="hidden"
        animate="visible"
        variants={staggerParent}
        className={`mx-auto flex w-full flex-col ${density === 'compact' ? 'gap-4' : 'gap-7'} px-4 pb-8 pt-5 ${
          width === 'wide' ? 'max-w-3xl' : 'max-w-xl'
        }`}
      >
        {children}
      </motion.div>
    </div>
  )
}
